import React, { useState } from 'react';

const PhoneInput = ({ 
  value = '', 
  onChange, 
  label = '电话号码', 
  placeholder = '13800138000',
  required = false,
  className = '',
  disabled = false,
  type = 'domestic' // 'domestic' 或 'international'
}) => {
  const [error, setError] = useState('');

  // 验证电话号码格式
  const validatePhone = (phone) => {
    if (!phone) return '';
    
    let phoneRegex;
    let errorMessage;
    
    if (type === 'international') {
      // 国际电话号码格式：+国家代码-号码
      phoneRegex = /^\+[1-9]\d{0,3}-\d{6,14}$/;
      errorMessage = '请输入有效的国际电话号码格式（如：+86-13800138000）';
    } else {
      // 中国手机号码格式：11位数字，以1开头
      phoneRegex = /^1[3-9]\d{9}$/;
      errorMessage = '请输入有效的中国手机号码（11位数字，以1开头）';
    }
    
    if (phoneRegex.test(phone)) {
      return '';
    }
    
    return errorMessage;
  };

  // 处理输入变化
  const handleChange = (e) => {
    let inputValue = e.target.value;
    
    if (type === 'international') {
      // 国际号码：只允许数字、加号和连字符
      inputValue = inputValue.replace(/[^\d+-]/g, '');
      
      // 确保只有一个加号且在开头
      const plusCount = (inputValue.match(/\+/g) || []).length;
      if (plusCount > 1) {
        inputValue = inputValue.replace(/\+/g, (match, index) => {
          return index === 0 ? '+' : '';
        });
      }
      
      // 确保连字符在正确位置
      const dashCount = (inputValue.match(/-/g) || []).length;
      if (dashCount > 1) {
        inputValue = inputValue.replace(/-/g, (match, index) => {
          return index === inputValue.indexOf('+') + 2 ? '-' : '';
        });
      }
    } else {
      // 国内号码：只允许数字
      inputValue = inputValue.replace(/[^\d]/g, '');
      
      // 限制长度为11位
      if (inputValue.length > 11) {
        inputValue = inputValue.slice(0, 11);
      }
    }
    
    // 验证格式
    const validationError = validatePhone(inputValue);
    setError(validationError);
    
    // 调用父组件的onChange
    onChange(inputValue);
  };

  // 处理失去焦点时的验证
  const handleBlur = () => {
    if (value && !error) {
      const validationError = validatePhone(value);
      setError(validationError);
    }
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          type="tel"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`w-full h-12 px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
            error 
              ? 'border-red-300 bg-red-50 focus:ring-red-500' 
              : 'border-gray-300 bg-gradient-to-r from-white to-blue-50 shadow-sm hover:shadow-md'
          } ${disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : ''}`}
        />
        
        {/* 格式提示 */}
        {!error && value && validatePhone(value) === '' && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <div className="text-green-500">✓</div>
          </div>
        )}
      </div>
      
      {/* 错误信息 */}
      {error && (
        <p className="mt-1 text-sm text-red-600 flex items-center">
          <span className="w-4 h-4 mr-1">⚠️</span>
          {error}
        </p>
      )}
      
      {/* 帮助信息 */}
      {!error && !value && (
        <p className="mt-1 text-xs text-gray-500">
          {type === 'international' 
            ? '格式：+国家代码-号码，如：+86-13800138000'
            : '格式：11位数字，如：13800138000'
          }
        </p>
      )}
    </div>
  );
};

export default PhoneInput; 